import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { IngestConfigDto } from '../lib/types';

export function useIngestConfig() {
  return useQuery({
    queryKey: ['admin', 'ingest-config'],
    queryFn: () => apiClient.get<IngestConfigDto>('/api/admin/ingest/config'),
    staleTime: 5 * 60 * 1000,
  });
}
